import React, { useState } from 'react';
import { Link } from 'react-router-dom';


import IcoHome from'../../../acets/icon/home.svg'
import IcoCalender from'../../../acets/icon/calender.svg'
import IcoToken from'../../../acets/icon/token.svg'
import IcoProfile from'../../../acets/icon/profile.svg'
import IcoProject from'../../../acets/icon/project.svg'
import IcoStudio from'../../../acets/icon/studio.svg'


export default function menumain() {


return(
    <div className='w100 h90 b2 cont-circ7 column between bordaElements cell-tamanho cell-display-fixed'>
           {/* <div className='column between w90'>
              <div className='row around w100 pcb10 linha'>
              <div className='w20 h5 cont-circ50pc column center c3 b29'>U</div>
              <label className='w70'>Geovane Filgueira</label>
            </div>
          </div> 
          */ }
           
          <div className='column start w90 h40 m10 '>
            <div className='row between w90'>
              <div className='w20 h10  cont-circ7 row center '>
                <img src='https://api.multiavatar.com/teste.svg' className='w100'/>
              </div>
              <div className='w75 column  cell-tamanho-metade70'>
                <label className='w90 c1'>Geovane Filgueira de Almeida</label>
              </div>
            </div>
            <Link to="/painel" className='row around w90 pcb7 pp sobhover cont-circ7 ma20b0'>
              <img src={IcoHome} className='w10' alt='plus / mais'/>
              <label className='w80 pp fw500'>Inico - Home</label>
            </Link>
            <Link to="/engine" className='row around w90 pcb7 pp sobhover cont-circ7'>
              <img src={IcoStudio} className='w10' alt='plus / mais'/>
              <label className='w80 pp fw500'>Gerar Posts</label>
            </Link>
            <Link to="/calendario" className='row around w90 pcb7 pp sobhover cont-circ7'>
              <img src={IcoCalender} className='w10' alt='plus / mais'/>
              <label className='w80 pp fw500'>Agenda - Schedule</label>
            </Link>
            <Link to='/tokens' className='row around w90 pcb7 pp sobhover cont-circ7'>
            <img src={IcoToken} className='w10' alt='plus / mais'/>
              <label className='w80 pp fw500'>Tokens</label>
            </Link>
            <Link to='/projeto' className='row around w90 pcb7 pp sobhover cont-circ7'>
            <img src={IcoProject} className='w10' alt='plus / mais'/>
              <label className='w80 pp fw500'>Projetos - Projects</label>
            </Link>
            <Link to='/perfil' className='row around w90 pcb7 pp sobhover cont-circ7'>
              <img src={IcoProfile} className='w10' alt='plus / mais'/>
              <label className='w80 pp fw500'>Perfil - Profile</label>
            </Link>
            {/*
            <Link to="/teste" className='row around w90 pcb7 pp sobhover cont-circ7'>
            <img src='https://cdn-icons-png.flaticon.com/128/10975/10975957.png' className='w10' alt='plus / mais'/>
              <label className='w80 pp fw500'>teste</label>
            </Link>
           */}
            
           
          </div>

          <div className='h40 column w90'>
            <div className='row around w90 pcb7 pp sobhover cont-circ7'>
              <img src='https://cdn-icons-png.flaticon.com/128/11511/11511728.png' className='w10' alt='plus / mais'/>
              <label className='w80 pp fw500'>Ajuda - Help</label>
            </div>
            <div className='row around w90 pcb7 pp sobhover cont-circ7'>
              <img src='https://cdn-icons-png.flaticon.com/128/9265/9265782.png' className='w10' alt='plus / mais'/>
              <label className='w80 pp fw500'>Configurações</label>
            </div>
            <Link to="/" className='row around w90 pcb7 pp sobhover cont-circ7'>
              <img src='https://cdn-icons-png.flaticon.com/128/8377/8377213.png' className='w10' alt='plus / mais'/>
              <label className='w80 pp fw500'>Sair - Exit</label>
            </Link>
          </div>
      </div>
)

}